import React, { useState, useEffect } from 'react';
import { TextField, RadioGroup, FormControlLabel, Radio, Box, Typography } from '@material-ui/core';

export const Question = ({ question, saveAnswer, defaultAnswer }) => {

    const [updatedAnswer, setUpdatedAnswer] = useState();  //updatedAnswer will have answer

    useEffect(() => {
        console.log("default Answer: " + JSON.stringify(defaultAnswer));
        if (defaultAnswer && defaultAnswer.answer) {
            setUpdatedAnswer(defaultAnswer);
        } else if (defaultAnswer && defaultAnswer.answerOptions) {
            setUpdatedAnswer({ "answer": defaultAnswer.answerOptions[0].questionOptionId });
        } else {
            setUpdatedAnswer("");
        }
    }, [question]);

    const handleOnChangeInput = (e) => {
        setUpdatedAnswer({
            "answer": e.target.value
        });
        saveAnswer({
            "answer": e.target.value,
            "questionId": question.id
        });
    }

    const handleOnChangeRadio = (e) => {
        setUpdatedAnswer({
            "answer": e.target.value //access current value  when the event in triggered
        })
        saveAnswer({
            "questionId": question.id,
            "answerOptions": [
                { "questionOptionId": e.target.value }
            ]
        })
    }

    return (
        <Box px={1} py={2}>
            <Box mb={1.5}>
                <Typography
                    variant="body2"
                    component="h2"
                    gutterBottom
                    style={{ fontWeight: 600 }}
                >
                    {question.title}
                </Typography>
                <Typography variant="body2" component="p" color="textSecondary">
                    {question.body}
                </Typography>
            </Box>

            {question.questionType.title === "DATA_INPUT" ? (
                <Box mt={2}>
                    <TextField
                        required
                        fullWidth
                        id="outlined-error-helper-text"
                        label="Svar"
                        name="answer"
                        value={updatedAnswer && updatedAnswer.answer ? updatedAnswer.answer : ""}
                        onChange={e => handleOnChangeInput(e)}
                    />
                </Box>
            ) : null}

            {question.questionType.title === "SELECT_ONE" ? (
                <Box mt={2}>
                    <RadioGroup
                        aria-label="answer"
                        name="answer"
                        value={updatedAnswer && updatedAnswer.answer ? updatedAnswer.answer : ""}
                        onChange={e => handleOnChangeRadio(e)}
                    >
                        {question.questionOptions.map(questionOption =>
                            <FormControlLabel
                                key={questionOption.id}
                                value={questionOption.id.toString()}
                                control={<Radio color="primary" size="small" />}
                                label={
                                    <Typography variant="body2">
                                        {questionOption.title}
                                    </Typography>
                                }
                                style={{ marginBottom: 4 }}
                            />
                        )}
                    </RadioGroup>
                </Box>
            ) : null}
        </Box>
    );
}